import { render } from "./seeLogistics.vue?vue&type=template&id=16a59b69&scoped=true"
import script from "./seeLogistics.vue?vue&type=script&lang=js"
export * from "./seeLogistics.vue?vue&type=script&lang=js"

import "./seeLogistics.vue?vue&type=style&index=0&id=16a59b69&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a59b69"]])

export default __exports__